import axios from "axios";

import { fetcher } from "#app/http/fetcher";
import { ApiErrorBody } from "#shared/infra/apiError";

export type ExportValidationError = {
  errors: Array<{
    type: "required_missing" | "mapping_missing" | "invalid_expression" | "invalid_format";
    message: string;
    context?: Record<string, unknown>;
  }>;
  warnings: Array<{
    type: "truncated" | "empty_section" | "format_conversion";
    message: string;
    context?: Record<string, unknown>;
  }>;
};

export const downloadZipExport = async ({
  url,
  body,
  filename,
}: {
  url: string;
  body: Record<string, unknown>;
  filename: string;
}): Promise<void> => {
  try {
    const response = await fetcher.post(url, body, {
      responseType: "blob",
      timeout: 30000, // 30 seconds for large exports
    });

    const blob = new Blob([response.data], { type: "application/zip" });
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 400) {
      const data = error.response.data;

      if (data instanceof Blob) {
        const text = await data.text();
        const errorResponse = JSON.parse(text) as ApiErrorBody;

        const domainException = errorResponse.domainException;
        if (
          domainException &&
          typeof domainException === "object" &&
          "code" in domainException &&
          domainException.code === "EXPORT.VALIDATION_FAILED" &&
          "params" in domainException
        ) {
          throw domainException.params as ExportValidationError;
        }
      }

      throw data as ExportValidationError;
    }
    throw error;
  }
};
